import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchagentmarkup,
  DoUpdateaAgentmarkup,
  selectCurrentUser,
  ForgotPassword,
  ResetPassword,
  logoutUser,
} from "./authSlice";
import { toast } from "react-hot-toast";
import { Eye, EyeOff } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { maskPhone } from "../../utils/maskPhone";

export default function Markup() {
  const {
    agentmarkup,
    agentmarkupstatus,
    ForgotPasswordstatus,
    ForgotPasswordData,
    ResetPasswordstatus,
    ResetPasswordData,
  } = useSelector((state) => state.auth);
  const [loading, setloading] = useState(false);
  const user = useSelector(selectCurrentUser);
  const dispatch = useDispatch();
  const [formData, setFormData] = useState([]);

  const navigate = useNavigate();
  useEffect(() => {
    dispatch(fetchagentmarkup());
  }, [dispatch]);

  const [formDataReset, setFormDataReset] = useState({
    email: user?.UserData?.email,
    token: "",
    otp: "",
    password: "",
    password_confirmation: "",
    phone: user?.UserData?.mobile,
  });
  const handleChange = (e, index) => {
    const { name, value } = e.target;

    setFormData((prevData) => prevData.map((item, i) => (i === index ? { ...item, [name]: value } : item)));
  };

  useEffect(() => {
    setFormData(agentmarkup?.data);
  }, [agentmarkup, agentmarkupstatus]);

  const handleProceed = async (e) => {
    e.preventDefault();
    setloading(true);
    try {
      const response = await dispatch(DoUpdateaAgentmarkup(formData)).unwrap();
      const { data } = response;
      if (data?.status?.success) {
        localStorage.setItem("agent_markup", JSON.stringify(formData));
        setloading(false);
        toast.success(data?.message, { autoClose: 2000 });
      } else {
        toast.error(data?.message, { autoClose: 2000 });
        setloading(false);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleChangeResetPassword = (e) => {
    setFormDataReset({
      ...formDataReset,
      [e.target.name]: e.target.value,
    });
  };

  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);

  const handleforgotPassword = async (e) => {
    e.preventDefault();
    const CheckUser = {
      email: formDataReset?.email,
    };
    if (formDataReset.email === "") {
      toast.error("Please enter email id", { autoClose: 2000 });
      return false;
    }

    if (formDataReset.password === "") {
      toast.error("Please new password", { autoClose: 2000 });
      return false;
    }
    if (formDataReset.password_confirmation === "") {
      toast.error("Please password confirmation", { autoClose: 2000 });
      return false;
    }
    if (formDataReset.password_confirmation !== formDataReset.password) {
      toast.error("Please new password and confirm password not matched!", { autoClose: 2000 });
      return false;
    }
    dispatch(ForgotPassword(CheckUser));
  };

  useEffect(() => {
    if (ForgotPasswordstatus === "success" && ForgotPasswordData?.status?.success === true) {
      setFormDataReset({
        ...formDataReset,
        ["email"]: formDataReset?.email,
        ["reset_token"]: ForgotPasswordData?.token,
        ["phone"]: ForgotPasswordData?.mobile,
      });
      toast.success(ForgotPasswordData?.message, { autoClose: 2000 });
    } else if (ForgotPasswordstatus === "success" && ForgotPasswordData?.status?.success === false) {
      toast.error(ForgotPasswordData?.message, { autoClose: 2000 });
    }
  }, [ForgotPasswordData, ForgotPasswordstatus]);

  const SubmitforgotPassword = async (e) => {
    if (formDataReset.otp === "") {
      toast.error("Please enter OTP", { autoClose: 2000 });
      return false;
    }
    if (formDataReset.password === "") {
      toast.error("Please new password", { autoClose: 2000 });
      return false;
    }
    if (formDataReset.password_confirmation === "") {
      toast.error("Please password confirmation", { autoClose: 2000 });
      return false;
    }
    if (formDataReset.password_confirmation !== formDataReset.password) {
      toast.error("Please new password and confirm password not matched!", { autoClose: 2000 });
      return false;
    }

    dispatch(ResetPassword(formDataReset));
  };
  useEffect(() => {
    if (ResetPasswordstatus === "success" && ResetPasswordData?.status?.success === true) {
      toast.success(ResetPasswordData?.message, { autoClose: 3000 });
      dispatch(logoutUser());
      navigate("/");
    } else if (ResetPasswordstatus === "success" && ResetPasswordData?.status?.success === false) {
      toast.error(ResetPasswordData?.message, { autoClose: 2000 });
    }
  }, [ResetPasswordData, ResetPasswordstatus]);

  return (
    <>
      {user.UserData.user.UserType != 6 && user.UserData.user.UserType != 7 && (
        <form onSubmit={handleProceed} className="mui-form">
          <div className="max-w-6xl mx-auto p-4 bg-white shadow rounded-lg mt-4">
            {agentmarkupstatus === "pendig" && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                <div className="bg-white p-6 rounded-xl shadow-lg w-80 text-center">
                  <h2 className="text-lg font-semibold mb-4">Please wait....</h2>
                  <div className="mt-6 flex flex-col items-center justify-center">
                    <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
                  </div>
                </div>
              </div>
            )}
            <div className="flex items-start justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-800">Markup</h3>
            </div>

            <hr className="border-t border-gray-200 my-3" />
            {/* Personal Details */}
            <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4">
              <div>
                <div className="w-full text-sm pr-2">
                  <div className="text-sm">
                    <table className="w-full border border-gray-300 text-sm">
                      <thead>
                        <tr className="bg-blue-100">
                          <th className="border border-gray-300 px-4 py-2 text-left font-semibold">Type</th>
                          <td className="border border-gray-300 px-4 py-2 text-left font-semibold">Markup (Fixed)</td>
                        </tr>
                      </thead>
                      <tbody>
                        {formData?.map((SegItem, Segkey) => (
                          <>
                            <tr className="border-t" key={Segkey}>
                              <td className="border border-gray-300 px-4 py-3">
                                {SegItem.api_source_id === 1 ? (
                                  <>Flight {SegItem.type === 0 ? "Domestic" : "International"}</>
                                ) : (
                                  <>Hotel {SegItem.type === 0 ? "Domestic" : "International"}</>
                                )}
                              </td>
                              <td className="border border-gray-300 px-4 py-3">
                                <input
                                  type="number"
                                  value={SegItem.markup}
                                  name="markup"
                                  onChange={(e) => handleChange(e, Segkey)}
                                  className=" border rounded-lg px-3 py-2"
                                  placeholder="Markup Value"
                                />
                              </td>
                            </tr>
                          </>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            {/* Submit Button */}
            <div className="mt-8 text-right">
              <button
                variant="contained"
                size="large"
                type="submit"
                disabled={loading}
                className={`bg-blue-500 text-white px-6 py-2 rounded-lg shadow hover:bg-blue-600 transition ${loading ? "bg-gray-400 cursor-not-allowed" : "bg-blue-500 hover:bg-blue-600"
                  }`}
              >
                {loading ? <>Please wait...</> : "Update"}
              </button>
            </div>
          </div>
        </form>
      )}
      {console.log(user.UserData.user.UserType)}
      <div className="max-w-6xl mx-auto p-4 bg-white shadow rounded-lg mt-4">
        <div className="w-full lg:w-1/2">
          <div className="flex items-start justify-between mb-4">
            <h3 className="text-lg font-semibold text-gray-800">Change Password</h3>
          </div>
          <hr className="border-t border-gray-200 my-3" />
          <form onSubmit={handleforgotPassword}>
            <div className="mb-4">
              <label className="block text-gray-700 mb-2" htmlFor="password">
                New Password
              </label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  value={formDataReset.password}
                  onChange={handleChangeResetPassword}
                  className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 pr-10"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute inset-y-0 right-3 flex items-center text-gray-500 hover:text-gray-700 focus:outline-none"
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 mb-2" htmlFor="password">
                Password Confirmation
              </label>
              <div className="relative">
                <input
                  type={showPasswordConfirm ? "text" : "password"}
                  id="password_confirmation"
                  name="password_confirmation"
                  value={formDataReset.password_confirmation}
                  onChange={handleChangeResetPassword}
                  className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 pr-10"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPasswordConfirm(!showPasswordConfirm)}
                  className="absolute inset-y-0 right-3 flex items-center text-gray-500 hover:text-gray-700 focus:outline-none"
                >
                  {showPasswordConfirm ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>

            {ForgotPasswordstatus === "pendig" || ForgotPasswordstatus === "idle" ? (
              <>
                <div className="mt-8 text-right">
                  <div className=" mb-6">
                    <button
                      type="submit"
                      disabled={ForgotPasswordstatus === "pendig"}
                      className="bg-blue-500 text-white px-6 py-2 rounded-lg shadow hover:bg-blue-600 transition"
                    >
                      {ForgotPasswordstatus === "pendig" ? "Please wait..." : "Request OTP"}
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="mb-4">
                  <label className="block text-gray-700 mb-2" htmlFor="email">
                    Enter OTP
                  </label>
                  <input
                    type="text"
                    id="otp"
                    name="otp"
                    value={formDataReset.otp}
                    onChange={handleChangeResetPassword}
                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>
                <div className="mt-8 text-right">
                  <small className="text-sm text-gray-600 text-right">
                    OTP has been shared with your mobile ending in {maskPhone(formDataReset?.phone, 2)}
                  </small>
                  <div className=" mb-6">
                    <button
                      onClick={SubmitforgotPassword}
                      type="button"
                      disabled={ResetPasswordstatus === "pendig"}
                      className="bg-blue-500 text-white px-6 py-2 rounded-lg shadow hover:bg-blue-600 transition"
                    >
                      {ResetPasswordstatus === "pendig" ? "Please wait..." : "Submit"}
                    </button>
                  </div>
                </div>
              </>
            )}
          </form>
        </div>
      </div>
    </>
  );
}
